import { RegionCondition, TagCondition } from '@ariksa/inventory-core';

export const regionConditionOptions = [
  { label: 'is in region', value: RegionCondition.InRegion },
  { label: 'is not in region', value: RegionCondition.NotInRegion },
];

export const tagKeyConditionOptions = [
  { label: 'is tagged', value: TagCondition.Tagged },
  { label: 'is not tagged', value: TagCondition.NotTagged },
];

// Account label for the select; falls back to the id when the account isn't in the mapping.
export const getAccountLabel = (
  accountId: string,
  account?: Record<string, any>,
) =>
  account ? account.name + ' (' + account.cloud_account_id + ')' : accountId;
